const url = {
    dev: {
        // publicUrl: 'http://127.0.0.1:9504/admin',
        // manageUrl: 'http://127.0.0.1:9504/admin'

        publicUrl: 'https://test.api.cxc-group.com/api/admin',
        manageUrl: 'https://test.api.cxc-group.com/api/admin'
    },
    pro: {
        publicUrl: 'https://api.cxc-group.com/api/admin',
        manageUrl: 'https://api.cxc-group.com/api/admin'
    }
}

export const get = () => {
    if(process.env.NODE_ENV === 'production'){
        return url['pro']
    }else{
        return url['dev']
    }
}
